import React from "react";
import DatePicker from "react-datepicker";
import "./react-datepicker.min.css";

type Props = {
  isDisabled?: boolean;
  defaultValue?: any;
  handleDataChange?: (date: any) => void;
  placeholder: string;
  [key: string]: any;
};

const ReactDatePicker = ({
  isDisabled,
  defaultValue,
  handleDateChange,
  placeholder,
  ...rest
}: Props) => {
  const [startDate, setStartDate] = React.useState(defaultValue);
  return (
    <DatePicker
      minDate={new Date()}
      disabled={isDisabled}
      selected={startDate}
      onChange={(date) => {
        setStartDate(date);
        handleDateChange(date);
      }}
      disabledKeyboardNavigation
      placeholderText={placeholder}
      popperPlacement="top-end"
      popperModifiers={
        [
          {
            name: "offset",
            options: {
              offset: [5, 10],
            },
          },
          {
            name: "preventOverflow",
            options: {
              rootBoundary: "viewport",
              tether: false,
              altAxis: true,
            },
          },
        ] as any
      }
      {...rest}
    />
  );
};

export default ReactDatePicker;
